export default __webpack_public_path__ + "static/media/xlsx.9edb1ae8.svg";